import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function ResetPassword() {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const token = searchParams.get("token");
    const email = searchParams.get("email");

    const [form, setForm] = useState({
        password: "",
        password_confirmation: ""
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {

        setForm({
            ...form,
            [e.target.name]: e.target.value
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);

        try {

            const response = await fetch(
                "/admin/reset-password",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({

                        email,
                        token,
                        password: form.password,
                        password_confirmation: form.password_confirmation

                    })
                }
            );

            const data = await response.json();

            if (data.success) {

                alert("Password Changed Successfully");

                navigate("/admin/login");

            } else {

                alert(data.message);

            }

        } catch {

            alert("Server Error");

        }

        setLoading(false);

    };

    return (

        <div className="min-h-screen bg-black flex items-center justify-center">

            <div className="bg-white rounded-xl p-8 w-full max-w-md">

                <h2 className="text-3xl font-bold mb-6">

                    Reset Password

                </h2>

                <form onSubmit={handleSubmit}>

                    <input
                        type="password"
                        name="password"
                        placeholder="New Password"
                        onChange={handleChange}
                        className="w-full border p-3 rounded mb-4"
                    />

                    <input
                        type="password"
                        name="password_confirmation"
                        placeholder="Confirm Password"
                        onChange={handleChange}
                        className="w-full border p-3 rounded mb-6"
                    />

                    <button
                        className="w-full bg-[#FED547] p-3 rounded font-bold"
                    >

                        {loading ? "Please Wait..." : "Reset Password"}

                    </button>

                </form>

            </div>

        </div>

    );

}